import { MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST, MRD_DENEST_IMPC_MAPPING_DEACTIVATE_SUCCESS, MRD_DENEST_IMPC_MAPPING_DEACTIVATE_FAILURE } from '../actions/types/DenestImpcMappingActionTypes';

export const initialState = {
  saveRequestResponse: '',
};

const DenestImpcsReducer = (state = initialState, action) => {
  switch (action.type) {
  case MRD_DENEST_IMPC_MAPPING_DEACTIVATE_SUCCESS:
    return {
      saveRequestResponse: 'success',
    };
  case MRD_DENEST_IMPC_MAPPING_DEACTIVATE_FAILURE:
    return {
      saveRequestResponse: 'fail',
    };
  case MRD_DENEST_IMPC_MAPPING_DEACTIVATE_REQUEST:
    return initialState;
  default: return state;
  }
};

export default DenestImpcsReducer;
